var _defs, _polygon, _polygon2, _polygon3, _polygon4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaiRwareLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3137.4 472.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#22aae1;}.cls-1,.cls-2,.cls-3,.cls-4{fill-rule:evenodd;}.cls-2{fill:#005aaa;}.cls-3{fill:#8dc73f;}.cls-4{fill:#2a2a86;}.cls-5{fill:#25aae1;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "236.18 118.09 236.18 0 0 0 0 236.18 118.09 236.18 118.09 118.09 236.18 118.09"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "236.18 354.27 236.18 236.18 0 236.18 0 472.36 118.09 472.36 118.09 354.27 236.18 354.27"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "236.18 354.27 354.27 354.27 354.27 118.09 118.09 118.09 118.09 236.18 236.18 236.18 236.18 354.27"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "354.27 236.18 472.36 236.18 472.36 0 236.18 0 236.18 118.09 354.27 118.09 354.27 236.18"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M994.74,242.57h276.7V306.7H1077.2V407.49h171.64V471H1077.2V635.94H994.74Z",
    transform: "translate(-353.73 -234.04)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1405.82,242.57h90.4l149.65,393.37h-85.52l-37.26-94.68H1378.33l-36.65,94.68h-86.13Zm105.06,235.17-60.47-158.21-59.87,158.21Z",
    transform: "translate(-353.73 -234.04)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1703.28,242.57h82.46V635.94h-82.46Z",
    transform: "translate(-353.73 -234.04)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1855.37,242.57h188.75q66,0,98.64,34.82t32.68,97.12q0,39.71-20.46,68.41t-57.72,41.53a81.7,81.7,0,0,1,15,16.8q5.81,8.87,12.53,24.74l47.64,110h-85.52l-46.42-105.67q-6.1-14.06-13.74-19.25t-24.13-5.19h-64.75V635.94h-82.46Zm167.37,194.85q33.59,0,51.31-15t17.71-47.95q0-33-15.88-48.26T2027.62,311h-89.79V437.42Z",
    transform: "translate(-353.73 -234.04)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2212.09,346.41h82.46l44,188.13,48.25-150.87V346.41h62.92l55,188.13,42.76-188.13h81.85l-75.74,289.53H2477.8l-55.59-169.2-56.8,169.2h-77Z",
    transform: "translate(-353.73 -234.04)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2677.22,618.53q-29.62-23.5-29.62-66.28,0-43.35,30.84-68.71t88.88-25.35h85.51v-7.94q0-18.33-6.41-28.71t-22.6-15.27q-16.2-4.89-46.12-4.89a299.69,299.69,0,0,0-95.29,15.27v-58q21.38-8.53,50.4-13.43a373,373,0,0,1,62-4.89q136.83,0,136.83,111.78V635.94h-71.47l-4.27-26.27q-35.43,32.39-105.06,32.38Q2706.85,642.05,2677.22,618.53Zm142.93-39.7q20.46-8.85,32.68-23.52V509.5h-83.68q-48.26,0-48.25,39.7,0,38.49,52.53,38.48Q2799.68,587.68,2820.15,578.83Z",
    transform: "translate(-353.73 -234.04)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2998.2,346.41h76.35l3.67,29.93q20.15-12.82,48.86-22.6a294.29,294.29,0,0,1,56.81-13.44v62.3a389.23,389.23,0,0,0-56.2,12.53q-29.93,8.85-47,18.63V635.94H2998.2Z",
    transform: "translate(-353.73 -234.04)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M3248.32,603.87q-43.05-38.18-43.06-113.31,0-70.85,37.57-110.56t109.64-39.7q66,0,102.31,34.51t36.34,92.54v52.53H3281.61q6.1,33.6,30.85,47t73,13.44a271.1,271.1,0,0,0,47.34-4.27q24.12-4.27,41.23-11v58.64q-40.3,18.33-105.67,18.33Q3291.39,642.05,3248.32,603.87Zm170.73-134.69V453.3q0-53.74-64.14-53.75-40.3,0-56.8,16.19t-16.5,53.44Z",
    transform: "translate(-353.73 -234.04)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaiRwareLogo);
export default __webpack_public_path__ + "static/media/FAIRwareLogo.857c1655fb0fbe6bf2e38c0f50c8a846.svg";
export { ForwardRef as ReactComponent };